import { SERVER_URL } from '../../../Constants';
import axios from 'axios';
import { buildUrl } from '../../../Util/FetchUtils';

export function downloadInvoice(
	transactionId: string,
	isEventBooking: boolean,
	isVoucherPurchase: boolean = false,
	isParkingPurchase: boolean = false,
	isAnytimeTicket: boolean = false,
) {
	const timezone = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
	window
		.open(
			`${SERVER_URL}/api/invoice/${transactionId}?isEventBooking=${isEventBooking}&isVoucherPurchase=${isVoucherPurchase}&isParkingPurchase=${isParkingPurchase}&isAnytimeTicket=${isAnytimeTicket}&timezone=${timezone}`,
			'_blank',
		)
		?.focus();
}
export function fetchUserInvoices(userId: string, skip: number, take: number, search?: string) {
	const params: Record<string, string> = {
		userId,
		skip: skip.toString(),
		take: take.toString(),
	};
	if (search) {
		params.search = search;
	}
	return axios.get(buildUrl(`${SERVER_URL}/api/invoice/get-all-invoices`, params));
}

export interface UserInvoicesCountDto {
	invoices: UserInvoicesDto[];
	count: number;
	// True when the server hid invoiced transactions from this (non-staff) customer's list. Drives
	// the "invoiced transactions are emailed to you" notice, since the hidden rows aren't returned.
	filtered: boolean;
}
export interface UserInvoicesDto {
	invoiceId: string;
	humanReadableId: string;
	createdDate: Date;
	invoiceAmount: number;
	isInvoiced: boolean;
	isVoucherPurchase: boolean;
	isEventBooking: boolean;
	isParkingPurchase: boolean;
	isAnytimeTicket: boolean;
	purchaseType: string;
}
